/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { useState } from 'react';
import { useIsLoaded } from './HookStateUpdate.jsx';
import { applySelectionToMolstar } from './molstar_utils.js';
import { DisabledSubmitInput } from './LoadButtons.jsx';

export function TextBoxSelection({ plugin }) {
    const isLoaded = useIsLoaded()
    const [pymolSelection, setpymolSelection] = useState();
    const [isStateok, setisStateok] = useState(false);

    let smallmessage = "Enter a residue selection using the syntax: chain ? and resi x-y + v-w You can also copy and paste a selection from the table below and adapt it.";
    let label = "Residue selection";

    const checkState = (event) => {
        const re = new RegExp('chain [A-Za-z0-9]{1,2}( and resi ([0-9\-+]*)*)?');
        if (re.test(event.target.value)) {
          console.log(re.test(event.target.value))
          setisStateok(true)
          setpymolSelection(event.target.value)
        }
        else {
          setisStateok(false)
          setpymolSelection('')
        }
    }

    const handleApplySelect = () => {
      applySelectionToMolstar(pymolSelection, plugin); // Calls the provided function to apply the selection    
      document.getElementById("analysis").scrollIntoView({behavior: "smooth"});
  };

    return (
        <div className=" w-full m-auto p-2 items-center justify-center relative" hidden={!isLoaded}>
            <h3 className="font-semibold dark:text-white">ENTER A PYMOL SELECTION</h3>
            <small className="text-gray-600 dark:text-gray-50">{smallmessage}</small>
            <div className="flex items-center justify-center space-x-2 h-full">
            <div className="relative flex h-full w-full">

            <input
              onChange={checkState}
              type="text"
              id='pymolselect'
              className="peer h-full w-full rounded-[7px] border border-gray-200 bg-transparent px-3 py-2.5 pr-20 text-sm font-normal text-gray-700 dark:text-gray-50 outline outline-0 transition-all placeholder-shown:border dark:placeholder-shown:border-gray-200 placeholder-shown:border-gray-700 dark:placeholder-shown:border-t-gray-200 placeholder-shown:border-t-gray-700 focus:border-2 dark:focus:border-sky-950 focus:border-sky-950 dark:focus:border-t-transparent focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-gray-50"
              placeholder=" "
              required
            />
            
            <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-gray-400 transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-gray-200 before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-gray-200 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:text-gray-500 peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-sky-950 dark:peer-focus:text-sky-950 peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:before:!border-sky-950 dark:peer-focus:before:!border-sky-950 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-focus:after:!border-sky-950 dark:peer-focus:after:!border-sky-950 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-gray-500">
              { label }
            </label>
          </div>
          <div className="flex h-full">
          <DisabledSubmitInput value="Apply Select" state={isStateok} handle={handleApplySelect}/>
          </div>
          </div>
        </div>
    );
}